import { render, staticRenderFns } from "./DetalheValorInput.vue?vue&type=template&id=f4fbfd26"
import script from "./DetalheValorInput.vue?vue&type=script&lang=js"
export * from "./DetalheValorInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports